import OpisFonda from "components/opis-fonda"

export default function Opis() {
  return (
		<OpisFonda />
  );
}
